import { createLifecycleTypes } from '@leagueplatform/web-common';

export const EDIT_EMPLOYEE_LIFECYCLE = createLifecycleTypes(
  'edit-employee/EDIT_EMPLOYEE_LIFECYCLE',
);

export const EMPLOYEE_FORM_SUBMITTED = 'edit-employee/EMPLOYEE_FORM_SUBMITTED';
